import { useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Scene from "../components/Scene";
import Marquee from "../components/Marquee";
import Pricing from "../components/Pricing";
import Gallery from "../components/Gallery";
import BeforeAfter from "../components/BeforeAfter";
import Standard from "../components/Standard";
import HowItWorks from "../components/HowItWorks";
import Footer from "../components/Footer";
import BookingModal from "../components/BookingModal";
import { IMAGES } from "../lib/constants";

export default function Home() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [preset, setPreset] = useState({});

  const openBooking = (p = {}) => {
    setPreset(p);
    setBookingOpen(true);
  };

  return (
    <div className="relative min-h-screen bg-midnight text-white font-body overflow-x-clip grain">
      <Navbar onBook={openBooking} />
      <main>
        <Hero onBook={openBooking} />

        <Scene
          image={IMAGES.heroClear}
          kicker="The Company"
          title={<>Everything Works Services is a locally owned window cleaning company.</>}
          body="Our vision is glass better than it was before — washed to disappear, detailed pane by pane, and trusted with the light you look through every day. Homes and storefronts across Naperville, Illinois. When we leave, you won't notice the window. That's the point."
          align="center"
          testid="scene-manifesto"
        />

        <Scene
          image={IMAGES.sceneStorefront}
          kicker="Scene 01 — Storefronts"
          title={<>Before your doors <em className="italic text-crystal">open.</em></>}
          body="Interior and exterior glass for shops and offices across Naperville — squeegee-detailed in the quiet hours before your customers ever touch the door."
          align="left"
          testid="scene-storefront"
        />

        <Marquee />
        <Pricing onBook={openBooking} />
        <Gallery />
        <BeforeAfter />
        <Standard />

        <Scene
          image={IMAGES.sceneInterior}
          kicker="Scene 02 — Inside & Out"
          title={<>Light, <em className="italic text-crystal">unobstructed.</em></>}
          body="The full pass, inside and out — every pane worked by hand until the garden feels like part of the room."
          align="right"
          testid="scene-interior"
        />

        <HowItWorks onBook={openBooking} />
      </main>
      <Footer />
      <BookingModal open={bookingOpen} onClose={() => setBookingOpen(false)} preset={preset} />
    </div>
  );
}
